module.exports = __webpack_public_path__ + "738e096f9532f0b31551f40627bb83e2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-baseball.png
// module id = 2247
// module chunks = 0